import Promise from 'promise-polyfill';
const REMOTE_POLYFILL_TIMEOUT = 500;
// Somehow the polyfill.io Object.entries is not enough
if (!Object.entries) {
    Object.entries = function (obj) {
        const ownProps = Object.keys(obj);
        let i = ownProps.length;
        const resArray = new Array(i); // preallocate the Array
        while (i--) {
            resArray[i] = [ownProps[i], obj[ownProps[i]]];
        }
        return resArray;
    };
}
// Quick fix for missing Object.fromEntries
if (!Object.fromEntries) {
    Object.fromEntries = (arr) => Object.assign({}, ...Array.from(arr, ([k, v]) => ({ [k]: v })));
}
// Quickfix for Element.getAttributeNames used in webomponents
if (Element.prototype.getAttributeNames === undefined) {
    Element.prototype.getAttributeNames = function () {
        const attributes = this.attributes;
        const length = attributes.length;
        const result = new Array(length);
        for (let i = 0; i < length; i++) {
            result[i] = attributes[i].name;
        }
        return result;
    };
}
const timeoutPromise = () => new Promise((_, reject) => {
    setTimeout(reject, REMOTE_POLYFILL_TIMEOUT);
});
const localPromise = (w, d) => new Promise((resolve) => {
    const id = 'fwn_polyfillio_ie11';
    const callbackName = '_fwnRender';
    w[callbackName] = () => {
        // console.info('FNW: Polyfills served from local source')
        resolve('LOCAL');
    };
    const script = d.createElement('script');
    script.id = id;
    script.async = true;
    script.src = `https://asset.fireworktv.com/js/static-ie11-polyfill.io.js`;
    script.type = 'text/javascript';
    d.head.appendChild(script);
});
const remotePromise = (w, d) => new Promise((resolve) => {
    const id = 'fwn_polyfillio';
    const callbackName = '_fwnRender_io';
    w[callbackName] = () => {
        resolve('REMOTE');
    };
    const features = [
        'AbortController',
        'Array.from',
        'Array.isArray',
        'Array.prototype.entries',
        'Array.prototype.every',
        'Array.prototype.fill',
        'Array.prototype.filter',
        'Array.prototype.find',
        'Array.prototype.findIndex',
        'Array.prototype.flat',
        'Array.prototype.forEach',
        'Array.prototype.includes',
        'Array.prototype.indexOf',
        'Array.prototype.keys',
        'Array.prototype.lastIndexOf',
        'Array.prototype.map',
        'Array.prototype.reduce',
        'Array.prototype.some',
        'Array.prototype.values',
        'ArrayBuffer',
        'Blob',
        'console',
        'CustomEvent',
        'DataView',
        'Date.now',
        'Date.prototype.toISOString',
        'document',
        'document.currentScript',
        'Element',
        'Event',
        'fetch',
        'Float32Array',
        'Function.prototype.bind',
        'IntersectionObserver',
        'JSON',
        'localStorage',
        'Map',
        'modernizr:es5object',
        'Number.isNaN',
        'Object.assign',
        'Object.entries',
        'Object.freeze',
        'Object.getOwnPropertyDescriptors',
        'Object.getOwnPropertySymbols',
        'Object.isFrozen',
        'Object.seal',
        'Object.setPrototypeOf',
        'Object.values',
        'Promise',
        'Reflect',
        'Reflect.construct',
        'requestAnimationFrame',
        'requestIdleCallback',
        'ResizeObserver',
        'Set',
        'String.prototype.includes',
        'String.prototype.startsWith',
        'String.prototype.trim',
        'String.prototype.padEnd',
        'Symbol',
        'Symbol.for',
        'Symbol.iterator',
        'Symbol.prototype.description',
        'Symbol.toStringTag',
        'Uint16Array',
        'Uint8Array',
        'URL',
        'URLSearchParams',
        'WeakMap',
        'WeakSet',
        'XMLHttpRequest',
    ];
    const script = d.createElement('script');
    script.src = `https://polyfill.io/v3/polyfill.min.js?features=${features.join('%2C')}&flags=gated&callback=${callbackName}`;
    script.id = id;
    script.async = true;
    script.type = 'text/javascript';
    script.crossOrigin = 'anonymous';
    script.referrerPolicy = 'no-referrer';
    d.head.appendChild(script);
});
class EnsurePolyfilled {
    constructor() {
        this.render = (w, d, callback) => {
            this.polyfillCallbacks.push(callback);
            Promise.race([
                (this.timeoutPromise = this.timeoutPromise || this.timeoutPromiseFn()),
                (this.remotePromise = this.remotePromise || this.remotePromiseFn(w, d)),
            ])
                .then((value) => Promise.resolve(value), () => {
                return (this.localPromise =
                    this.localPromise || this.localPromiseFn(w, d));
            })
                .then(() => {
                let callback;
                while ((callback = this.polyfillCallbacks.pop()) !== undefined) {
                    callback();
                }
            });
        };
        this.polyfillCallbacks = [];
        this.timeoutPromiseFn = timeoutPromise;
        this.remotePromiseFn = remotePromise;
        this.localPromiseFn = localPromise;
    }
}
export default window['_fwn_ensurePolyfilled'] =
    window['_fwn_ensurePolyfilled'] || new EnsurePolyfilled();
